var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramInternational40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "International40",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./International48",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramInternational",
    transform: "translate(3.750000, 3.750000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "World-Outline",
    fill: "#FFFFFF",
    cx: 11.25,
    cy: 11.25,
    r: 10.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61392785,4.55153817 L7.84225313,4.56689892 C8.76024914,4.66090305 9.44709043,5.15052384 10.0854589,5.77401841 C10.7119394,6.39212314 11.3643541,6.99892159 12.0313336,7.19700392 C12.3375023,7.28793114 12.6481383,7.30289169 12.9561622,7.21859357 C13.045455,7.19415644 13.1349742,7.16128673 13.224299,7.11866529 L13.25,7.104 L13.1441031,7.2211782 C13.1058217,7.26694763 13.0688179,7.31517556 13.0331637,7.36602261 L12.9303221,7.5265817 C12.5084596,8.24828764 12.5249283,9.02241419 12.8306457,9.67512755 C13.1466347,10.3497709 13.7808186,10.8935815 14.5637788,11.0955295 C15.0335482,11.195313 15.2715761,11.2022341 15.416778,11.3350234 C15.487523,12.225254 14.5750676,12.867452 14.0076113,13.345771 C13.7894943,13.5296257 13.5975578,13.6925542 13.4665567,13.8235612 C12.7034962,14.5803845 12.6577187,14.6469419 12.6577187,15.6143438 C12.6844878,16.5384386 12.7513809,17.1406226 12.444198,17.5954388 C12.1982464,17.9599069 11.77243,18.138761 11.3472476,18.1566641 C10.9139284,18.1749098 10.4644367,18.0272744 10.1829304,17.6858322 C9.63963505,17.0273188 9.78185482,15.905138 9.85035326,14.9298211 C9.88626347,14.4185127 9.91826822,13.9329367 9.88960517,13.5279221 C9.83873348,12.8065213 9.60502957,12.2576589 9.22342932,11.8564895 C8.8394222,11.4527897 8.29518895,11.1900098 7.57788715,11.0884885 C6.35158939,10.9150685 5.26832485,10.5397288 4.63509249,9.3738828 C4.34057453,8.83146753 4.22455548,8.25813286 4.25452885,7.7036007 C4.28706014,7.10174498 4.49048322,6.52249012 4.82038437,6.02793115 C5.15075309,5.53267125 5.60836684,5.12172206 6.1521778,4.85970046 C6.65358612,4.61810951 7.22830441,4.50408988 7.84225313,4.56689892 Z M11.4410423,0.739194145 C12.2551871,0.423075372 13.3407944,0.660226578 14.1381149,0.891202902 C15.6275093,1.32217478 17.0456309,2.05865854 18.2187989,3.07680203 C18.1899984,3.66949841 18.0439956,4.25162972 17.771054,4.75997173 C17.500118,5.26457847 17.1028806,5.69560853 16.5702137,5.98463325 C16.1901812,6.19099582 15.7429746,6.2423953 15.3053852,6.30378998 C14.7660276,6.37946295 14.248432,6.47215803 13.8051331,6.69895086 L13.769,6.718 L13.8660079,6.60992758 C14.108057,6.30314401 14.2241956,5.90104552 14.2179682,5.47491941 L14.2078178,5.29103069 C14.1553602,4.74046883 13.9046513,4.18432577 13.5445534,3.82422786 C13.1567785,3.43645293 12.6847746,3.33580387 12.1884256,3.2618649 C11.9534291,3.22685847 11.711244,3.20251033 11.4948574,3.07588052 C11.0527241,2.81726113 10.8309521,2.34831908 10.8275731,1.88438035 C10.8258388,1.64626178 10.8815256,1.40798991 10.9984664,1.19827923 C11.0995546,1.01699711 11.2469224,0.857760105 11.4410423,0.739194145 Z",
    id: "World",
    fill: "#FFCC00"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramInternational40);
export default __webpack_public_path__ + "static/media/pictogramInternational40.312d5ce41f331ec9322a343609fb52ef.svg";
export { ForwardRef as ReactComponent };